
import moment from 'moment';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

function BookingTable({
  data,
  status,
  onEditClick,

  // Bulk selection
  selectedBookingIds = [],
  onBookingSelection,
  onSelectAllBookings,
  allCurrentPageSelected,
}: any) {
  console.log('data ==> ', data);

  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] =
    useState<any>(null);

 const isBulkSelectable =
  status === 'Expired' ||
  status === 'Cancel';

  const handleEdit = (booking: any) => {
    onEditClick(booking);
  };

  const headers = [
    {
      name: 'Select',
      field: 'select',
      sortable: false,
    },
    {
      name: 'S.No.',
      field: '_id',
      sortable: false,
    },
    {
      name: 'Booking Id',
      field: 'id',
      sortable: false,
    },
    {
      name: 'Customer Name',
      field: 'customer',
      sortable: false,
    },
    {
      name: 'Number',
      field: 'number',
      sortable: false,
    },
    {
      name: 'Vehicle',
      field: 'vehicle',
      sortable: false,
    },
    {
      name: 'Booked By/Date Time',
      field: 'booked',
      sortable: false,
    },
    {
      name: 'Pickup Location',
      field: 'location',
      sortable: false,
    },
    {
      name: 'Drop Location',
      field: 'drop',
      sortable: false,
    },
    {
      name: 'Pickup Date Time',
      field: 'time',
      sortable: false,
    },
    {
      name: 'Reason',
      field: 'reason',
      sortable: false,
    },
    {
      name: 'Driver',
      field: 'driver',
      sortable: false,
    },
    {
      name: 'Driver status',
      field: 'driver_status',
      sortable: false,
    },
    {
      name: 'Status',
      field: 'status',
      sortable: false,
    },
    {
      name: 'Action',
      field: 'action',
      sortable: false,
    },
  ];

  return (
    <>
      <table className="table table-striped">
        <thead>
          <tr>
            {headers.map((header: any) => (
              <th key={header.field}>
                {header.field === 'select' ? (
                   isBulkSelectable ? (
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          allCurrentPageSelected
                        }
                        onChange={(e) =>
                          onSelectAllBookings(
                            e.target.checked
                          )
                        }
                        disabled={!data?.length}
                      />

                      <label className="form-check-label ms-1">
                        Select
                      </label>
                    </div>
                  ) : null
                ) : (
                  header.name
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.length > 0 ? (
            data.map(
              (item: any, index: number) => {
                const bookingId = Number(
                  item?.id
                );

                const isSelected =
                  selectedBookingIds.includes(
                    bookingId
                  );

                return (
                  <tr
                    key={
                      item?._id ||
                      item?.id ||
                      index
                    }
                  >
                    {/* SELECT */}
                    <td>
                      {isBulkSelectable && (
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isSelected}
                          onChange={(e) =>
                            onBookingSelection(
                              bookingId,
                              e.target.checked
                            )
                          }
                        />
                      )}
                    </td>

                    {/* S.NO */}
                    <td>
                      {index + 1}
                    </td>

                    {/* BOOKING ID */}
                    <td>
                      {item?.id}
                    </td>

                    {/* CUSTOMER NAME */}
                    <td>
                      {item?.user?.name}
                    </td>

                    {/* MOBILE NUMBER */}
                    <td>
                      {item?.user?.mobile}
                    </td>

                    {/* VEHICLE */}
                    <td>
                      {
                        item?.vehicle
                          ?.registration_number
                      }
                    </td>

                    {/* BOOKED BY / DATE TIME */}
                    <td>
                      {item?.date
                        ? moment(
                            item?.date
                          ).format(
                            'DD-MM-yyyy hh:mm:ss A'
                          )
                        : '--'}
                    </td>

                    {/* PICKUP LOCATION */}
                    <td>
                      {
                        item
                          ?.source_hydrant_center
                          ?.address
                      }
                    </td>

                    {/* DROP LOCATION */}
                    <td>
                      {
                        item?.destination
                          ?.address
                      }
                    </td>

                    {/* PICKUP DATE TIME */}
                    <td>
                      {item?.accepted_time
                        ? moment(
                            item?.accepted_time
                          ).format(
                            'DD-MM-yyyy hh:mm:ss A'
                          )
                        : '--'}
                    </td>

                    {/* REASON */}
                    <td>
                      {item?.reject_reason ||
                        '--'}
                    </td>

                    {/* DRIVER */}
                    <td>
                      {item?.driver?.name ||
                        '--'}
                    </td>

                    {/* DRIVER STATUS */}
                    <td>
                      <p>
                        {item?.driver_status ||
                          '--'}
                      </p>
                    </td>

                    {/* STATUS */}
                    <td>
                      <p>
                        {item?.status || '--'}
                      </p>
                    </td>

                    {/* ACTION */}
                    <td>
                      <button
                        type="button"
                        className="btn btn-info btn-sm"
                        onClick={() =>
                          handleEdit(item)
                        }
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              }
            )
          ) : (
            <tr>
              <td
                colSpan={headers.length}
                className="text-center"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* EXISTING BOOKING DETAILS MODAL */}
      <Modal
        show={showModal}
        onHide={() =>
          setShowModal(false)
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Booking Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedBooking && (
            <div>
              <p>
                <strong>
                  Booking ID:
                </strong>{' '}
                {selectedBooking.id}
              </p>

              <p>
                <strong>
                  Customer:
                </strong>{' '}
                {selectedBooking
                  ?.customer?.name ||
                  'N/A'}
              </p>

              <p>
                <strong>
                  Status:
                </strong>{' '}
                {selectedBooking.status}
              </p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BookingTable;





